module.exports = __webpack_public_path__ + "static/media/me_yellow.2435f808.svg";